import { LinkPlainExternal } from 'src/elements/links/Link.plain';
import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const PoliciesLinksListContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 1.5rem;

  @media screen and (max-width: ${layout.sm}) {
    column-gap: 1rem;
    text-align: center;
    padding: 0 6px;
    box-sizing: border-box;
  }
`;

export const PolicyLink = styled(LinkPlainExternal)`
  font-size: 0.75rem;
  font-weight: 300;
  color: ${palette.white};
  text-decoration: none;
  transition: filter 200ms ease-in-out;

  &:hover {
    filter: brightness(0.8);
  }
`;
